import { render, staticRenderFns } from "./successEmailPreference.vue?vue&type=template&id=33e1ad5e&scoped=true&"
import script from "./successEmailPreference.vue?vue&type=script&lang=ts&"
export * from "./successEmailPreference.vue?vue&type=script&lang=ts&"
import style0 from "./successEmailPreference.vue?vue&type=style&index=0&id=33e1ad5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e1ad5e",
  null
  
)

export default component.exports